export const isSrcBase64 = (src?: string) => {
    return src && src.indexOf('data:') === 0;
};
